import type { TeacherWorkload } from 'shared/api';
import type { TeacherWorkloadTableRow } from '../types';
import { mapQualificationsToRows } from './map-qualifications-to-rows';

export const rowsToQualificationRequests = (rows: TeacherWorkloadTableRow[]) =>
  rows.map((r) => ({
    subjectId: r.subjectId as number,
    workloadHours: r.workloadHours,
    educationalClassIds: r.educationalClasses,
  }));

const normalizeForCompare = (rows: TeacherWorkloadTableRow[]) =>
  rowsToQualificationRequests(rows).map((q) => ({
    subjectId: q.subjectId,
    workloadHours: q.workloadHours,
    educationalClassIds: [...q.educationalClassIds].sort((a, b) => a - b),
  }));

export const areQualificationRowsEqualToWorkload = (
  rows: TeacherWorkloadTableRow[],
  teacherWorkload: TeacherWorkload,
) => {
  const fromServer = mapQualificationsToRows(teacherWorkload);
  return (
    JSON.stringify(normalizeForCompare(rows)) === JSON.stringify(normalizeForCompare(fromServer))
  );
};

export const validateRowsForSave = (rows: TeacherWorkloadTableRow[]): string | null => {
  if (rows.length === 0) {
    return 'Добавьте хотя бы одну строку';
  }
  for (let i = 0; i < rows.length; i++) {
    if (rows[i].subjectId == null) {
      return `Выберите предмет в строке ${i + 1}`;
    }
    if (!rows[i].educationalClasses?.length) {
      return `Выберите классы в строке ${i + 1}`;
    }
  }
  return null;
};
